import { render, staticRenderFns } from "./AccountDomainLeaveOtherService.vue?vue&type=template&id=96fcc1f8&"
import script from "./AccountDomainLeaveOtherService.vue?vue&type=script&lang=ts&"
export * from "./AccountDomainLeaveOtherService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports